import { Component, Input, OnInit } from '@angular/core';
import { TermsCondsService } from '../../services/terms-conds.service';
import { AlertController, LoadingController } from '@ionic/angular';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent implements OnInit {

  @Input() isExternalOpen: boolean = false;

  isModalOpen: boolean = false;
  pdfSrc?: any;
  zoom = 1.0;

  constructor(
    private tycService: TermsCondsService,
    private loadingController: LoadingController,
    private alertController: AlertController
  ) { }

  async ngOnInit() {
    if (this.isExternalOpen) {
      this.getDocument('TyCApp');
      this.isModalOpen = this.isExternalOpen;
    }
  }

  async setOpen(isOpen: boolean) {
    if (isOpen) {
      this.getDocument('TyCApp');
    }
    this.isModalOpen = isOpen;
  }

  closeModalTerms() {
    this.isModalOpen = false;
  }

  async getDocument(type: string) {
    const loading = await this.loadingController.create();
    await loading.present();

    this.tycService.documentTermsAndCond(type).subscribe(async (doc: any) => {
      this.pdfSrc = await this.base64ToArrayBuffer(doc.document);
      await loading.dismiss();
    }, async (error) => {
      await loading.dismiss();
      console.log("ERROR TyC", error);
      this.showAlert('Error', 'No se pudieron cargar los términos y condiciones.');
      this.closeModalTerms();
    });
  }

  base64ToArrayBuffer(base64: any): any {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  zoomIn() {
    this.zoom += 0.25;
  }

  zoomOut() {
    if (this.zoom > 0.5) {
      this.zoom -= 0.25;
    }
  }

  async showAlert(header: string, message: string) {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: ['ok']
    });
    await alert.present();
  }
}
